<template>
  <div
    ref="flyIn"
    v-bind:class="
      (event.type === 'Lecture' && event.theme) || event.type === 'JigsawSession' || event.type === 'Workshop'
        ? 'event-item'
        : 'event-item--break'
    "
  >
    <template v-if="event.isFeatured">
      <img class="featured-background" v-bind:src="getFeaturedEventImage(event.starts)" />
    </template>
    <div class="time">
      <span>{{ event.starts | filterTimeFromDate }}-{{ event.ends | filterTimeFromDate }}</span>
      <div class="header__text" v-if="event.theme === 'Dev'">DEV</div>
      <div class="header__text" v-else-if="event.theme === 'Design'">DESIGN</div>
      <div class="header__text" v-else-if="event.theme === 'Tech'">TECH</div>
      <div class="header__text" v-else-if="event.theme === 'Marketing'">MARKETING</div>
    </div>
    <div class="content" v-bind:class="[event.isFeatured ? 'featured-content' : '']">
      <div class="header" v-if="event.theme">
        <div class="header__text" v-if="event.theme === 'Dev'">DEV</div>
        <div class="header__text" v-else-if="event.theme === 'Design'">DESIGN</div>
        <div class="header__text" v-else-if="event.theme === 'Tech'">TECH</div>
        <div class="header__text" v-else-if="event.theme === 'Marketing'">MARKETING</div>
        <div class="event-title">
          {{ event.name }}
        </div>
        <div class="event__pulser" v-if="hasStarted && !hasEnded">
          <span class="pulser" />
          <p>U tijeku</p>
        </div>
        <button class="button__expand button__expand--azure">
          <img src="@/assets/icons/chevron-bottom.svg" />
        </button>
      </div>
      <div class="event-title" v-if="!event.theme && event.name">
        <span>{{ event.name }}</span>
      </div>
      <div class="lecturers" v-if="event.eventUsers.length !== 0">
        <span v-if="event.eventUsers && event.eventUsers.length === 1">
          {{ event.eventUsers[0].user.firstName }}
          {{ event.eventUsers[0].user.lastName }}
          <span
            v-if="
              event.eventUsers &&
                event.eventUsers.length &&
                event.eventUsers[0].user &&
                event.eventUsers[0].user.lecturerTitle
            "
          >
            {{ event.eventUsers[0].user.lecturerTitle }}
          </span>
        </span>
        <template v-else>
          <span v-for="(eventUser, index) in getSortedEventUsers(event)" v-bind:key="eventUser.userId">
            <template v-if="eventUser.user">
              {{ eventUser.user.firstName }} {{ eventUser.user.lastName }}
              <span v-if="eventUser.user && eventUser.user.lecturerTitle">{{ eventUser.user.lecturerTitle }}</span>
              <span v-if="index !== event.eventUsers.length - 1">,</span>
            </template>
          </span>
        </template>
      </div>
      <div
        ref="description"
        class="description"
        v-if="event.description || (event.eventUsers && event.eventUsers.length)"
      >
        <div v-if="event.description" class="description__text">
          {{ event.description }}
          <a
            class="event-footage"
            v-if="event.footageLink && event.footageLink.length"
            v-bind:href="event.footageLink"
            target="_blank"
            rel="noreferrer"
          >
            <span class="video-link">Pogledaj predavanje</span>
          </a>
        </div>
        <div
          v-bind:class="{
            'section-user': true,
            'section-user--many': event.eventUsers && event.eventUsers.length && event.eventUsers.length > 3,
          }"
        >
          <div class="user-container" v-for="eventUser in getSortedEventUsers(event)" v-bind:key="eventUser.userId">
            <img
              v-bind:src="getSpeakerImage(getSpeakerNameNormalized(eventUser.user.firstName + eventUser.user.lastName))"
              v-bind:alt="`${eventUser.user.firstName} ${eventUser.user.lastName}`"
            />
            <div class="user-details">
              <div>
                <p class="user-fullname">{{ eventUser.user.firstName }} {{ eventUser.user.lastName }}</p>
                <p class="user-role">{{ eventUser.user.lecturerTitle }}</p>
              </div>
              <img
                class="schedule-logo"
                :class="getSponsorNameNormalized(eventUser.user.id)"
                :src="getSponsorLogo(eventUser.user.id)"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="schedule-action"
        v-if="
          (!hasEnded && event.type === 'Lecture' && event.theme) ||
            event.type === 'JigsawSession' ||
            event.type === 'Workshop'
        "
      >
        <button v-if="isAppliedOrFavorited()" v-on:click="removeFromFavoritedOrApplied" class="schedule-action__remove">
          <span>Ukloni</span>
        </button>
        <button v-else v-on:click="saveOrApply" class="schedule-action__add">
          <span>{{ appliedEvents ? 'Prijavi se' : 'Dodaj u raspored' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { eventMixin } from '@/mixins';
import { sponsorLogoExtensions } from '@/config';

export default {
  name: 'ScheduleItem',
  mixins: [eventMixin],
  props: {
    appliedEvents: null,
    favoritedEvents: null,
    refreshFavorites: Function,
  },
  data() {
    return {
      sponsorLogoExtensions,
    };
  },
  methods: {
    getSponsorNameNormalized(userId) {
      const eventUser = this.event.eventUsers.find(userEvent => userEvent.user.id === userId);

      return eventUser.user.company.name.replace(/\s/g, '').toLowerCase();
    },
    getSponsorLogo: function(userId) {
      const sponsorNameNormalized = this.getSponsorNameNormalized(userId);
      // eslint-disable-next-line
      return require(`@/assets/companies/logos/${sponsorNameNormalized}.${this.sponsorLogoExtensions[sponsorNameNormalized]}`);
    },
    getSpeakerImage: function(speakerNameNormalized) {
      // eslint-disable-next-line
      return require(`@/assets/speakers/images/${speakerNameNormalized}.jpg`);
    },
    isAppliedOrFavorited: function() {
      return (
        (this.appliedEvents && this.appliedEvents.filter(ae => ae.id === this.event.id).length !== 0) ||
        (this.favoritedEvents && this.favoritedEvents.filter(fe => fe.id === this.event.id).length !== 0)
      );
    },
    getFeaturedEventImage: function(startDateTime) {
      // eslint-disable-next-line
      return require(`@/assets/events/featured-${startDateTime.replace(/\s/g, '').replace(/:/g, '-')}.jpg`);
    },
    saveOrApply: function(e) {
      e.stopPropagation();
      if (this.event.type === 'Workshop') {
        this.$axios
          .post(`${this.$API_URL}/user/apply`, {
            eventId: this.event.id,
          })
          .then(() => {
            alert('Prijava na radionicu uspješna!');
            this.appliedEvents.push(this.event);
            this.$emit('refreshFavorites');
          })
          .catch(() => {
            alert('Prijava na događaj neuspješna. Nemaš dopuštenje ili je događaj već pun.');

            return;
          });
      } else {
        this.favoritedEvents.push(this.event);
        this.$axios.post(`${this.$API_URL}/user/grant-notification-achievement`).then(() => {});
        localStorage.setItem('favoritedEvents2020', JSON.stringify(this.favoritedEvents));
        this.$emit('refreshFavorites');
      }
    },
    removeFromFavoritedOrApplied: function(e) {
      e.stopPropagation();
      if (this.event.type === 'Workshop') {
        this.$axios
          .post(`${this.$API_URL}/user/remove-apply`, {
            eventId: this.event.id,
          })
          .then(() => {
            alert('Odjava s događaja uspješna! Žao nam je što ipak nećeš doći :(');
            this.appliedEvents.splice(
              this.appliedEvents.findIndex(ev => ev.id === this.event.id),
              1,
            );
          })
          .catch(() => {
            alert('Odjava s događaja neuspješna. Molimo te pokušaj opet.');

            return;
          });
      } else {
        this.favoritedEvents.splice(
          this.favoritedEvents.findIndex(ev => ev.id === this.event.id),
          1,
        );
        localStorage.setItem('favoritedEvents2020', JSON.stringify(this.favoritedEvents));
        this.$emit('refreshFavorites');
      }
    },
  },
};
</script>

<style>
.schedule-action {
  display: flex;
  align-items: center;
}
.schedule-action button {
  outline: none;
  border: 2px solid #5ec4bc;
  border-radius: 15px;
  padding: 12px 32px;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.2s ease-in;
}
.schedule-action__remove {
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
  color: rgba(255, 255, 255, 0.8) !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  background-color: transparent;
}
.schedule-action__remove:hover {
  border: 2px solid #fff !important;
  color: #fff !important;
}

.schedule-action__add {
  color: #0a181b;
  background-color: #30cec2;
  transition: background-color 0.3s ease-in-out;
}

.schedule-action__add:hover {
  background-color: #35e5d8;
}

@media screen and (max-width: 900px) {
  .schedule-action {
    width: 100%;
    justify-content: center;
  }
}
</style>
